import React, { useCallback, useState } from 'react';
import classNames from 'classnames';
import { useBreakpoint } from '@moda/om';
import PlayFilledIcon from '@moda/icons/play-filled-72';
import { ResponsiveImage } from '../../ResponsiveImage';
import { useDesktopProductMediaGalleryVideoThumb } from './useDesktopProductMediaGalleryVideoThumb';

import './DesktopProductMediaGalleryVideoThumb.scss';

interface Props {
  alt: string;
  index: number;
  selected: boolean;
  onClick: (index: number) => void;
  onMouseEnter: (index: number) => void;
  onError?: () => void;
  videoId: string;
}

export const DesktopProductMediaGalleryVideoThumb: React.FC<Props> = ({
  alt,
  index,
  selected,
  onClick,
  onMouseEnter,
  onError,
  videoId
}) => {
  const isMobile = useBreakpoint({ lt: 'md' }).matches;
  const handleClick = useCallback(() => onClick(index), [index, onClick]);
  const handleMouseEnter = useCallback(() => onMouseEnter(index), [index, onMouseEnter]);
  const { thumbnail } = useDesktopProductMediaGalleryVideoThumb(videoId);
  const [loaded, setLoaded] = useState(false);

  return (
    <button
      className={classNames('DesktopProductMediaGalleryVideoThumb', {
        'DesktopProductMediaGalleryVideoThumb--selected': selected
      })}
      onClick={handleClick}
      onMouseEnter={isMobile ? undefined : handleMouseEnter}
    >
      <ResponsiveImage
        className={classNames('DesktopProductMediaGalleryVideoThumb__image', {
          'DesktopProductMediaGalleryVideoThumb__image--loading': !loaded
        })}
        src={thumbnail}
        alt={alt}
        srcMode="static"
        maxWidth={80}
        onLoad={() => setLoaded(true)}
        maxHeight={110}
        onError={onError}
      />

      <div className="DesktopProductMediaGalleryVideoThumb__video-play-icon">
        <PlayFilledIcon height="36px" width="36px" />
      </div>
    </button>
  );
};
